import type { TStatusChipVariant } from '@team-milva/lab-components'

// Ordered for priority-picking UX — muted (gray) first as the default/unset
// look, then red=urgent ... blue, rather than StatusChip's own declaration order.
export const STATUS_CHIP_VARIANTS: TStatusChipVariant[] = [
  'muted',
  'red',
  'amber',
  'green',
  'blue',
  'neutral',
]

export const DEFAULT_STATUS_CHIP_VARIANT: TStatusChipVariant = 'muted'
